// extracted by mini-css-extract-plugin
export default {"key":"style_key__n7ITX","keyTitle":"style_keyTitle__-+pWB","value":"style_value__rH8JU","join":"style_join__AokdI","cancel":"style_cancel__SdeFZ","btnBlock":"style_btnBlock__PZ50J"};